const SAMPLE = {
  TEST: 'Test',
  TEST1: 'Test1',
  TEST2: 'Test2',
};

const API_RESPONSE_MESSAGE = {
  UNAUTHORIZED: 'Unauthorized',
  SUCCESS: 'success',
};

const API_RESPONSE_STATUS = {
  SUCCESS: '200',
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  INTERNAL_SERVER_ERROR: '500',
};

const CHATBOT_STATUS = {
  DRAFT: 'draft',
  LIVE: 'live',
};

const UI_STAFF = 'TGStaff@2025';

const ADMIN_TYPE = {
  SUPER_ADMIN: 'Super-Admin',
  DEPARTMENT: 'Department',
  SUB_DEPARTMENT: 'Sub-Department',
};

const QUOTA_TYPE = {
  SUB_DEPARTMENT: 'sub_department',
  FUNCTION_CODE: 'function_code',
  USER: 'user',
};

const ASSIGNMENT_TYPE = {
  DEPARTMENT: 'department_based',
  USER: 'user_based',
};

export const ENUM = {
  SAMPLE,
  API_RESPONSE_MESSAGE,
  CHATBOT_STATUS,
  API_RESPONSE_STATUS,
  UI_STAFF,
  ADMIN_TYPE,
  QUOTA_TYPE,
  ASSIGNMENT_TYPE,
};
